import React, { useState, useEffect } from 'react';
import { useAuth } from '../../contexts/AuthContext';
import Login from './Login';
import TwoFactorVerification from './TwoFactorVerification';
import { totpService } from '../../services/totpService';

const ProtectedRoute = ({ children }) => {
  const { user, loading } = useAuth();
  const [twoFactorRequired, setTwoFactorRequired] = useState(false);
  const [twoFactorVerified, setTwoFactorVerified] = useState(false);
  const [checking2FA, setChecking2FA] = useState(true);

  // 2FA 설정 확인
  useEffect(() => {
    const check2FA = async () => {
      if (user) {
        try {
          const twoFactorSettings = await totpService.getTwoFactorSettings(user.uid);
          if (twoFactorSettings && twoFactorSettings.enabled) {
            // 2FA가 활성화되어 있으면 인증 필요
            setTwoFactorRequired(true);
            // 세션에서 2FA 인증 상태 확인
            const session2FA = sessionStorage.getItem('2fa_verified');
            if (session2FA === user.uid) {
              setTwoFactorVerified(true);
            }
          } else {
            // 2FA가 비활성화되어 있으면 바로 통과
            setTwoFactorVerified(true);
          }
        } catch (error) {
          console.error('2FA 설정 확인 실패:', error);
          // 오류 발생 시 바로 통과
          setTwoFactorVerified(true);
        }
      }
      setChecking2FA(false);
    };

    check2FA();
  }, [user]);

  // 2FA 확인 성공 핸들러
  const handleTwoFactorSuccess = () => {
    // 세션에 2FA 인증 상태 저장
    sessionStorage.setItem('2fa_verified', user.uid);
    setTwoFactorVerified(true);
  };

  // 로그아웃
  const handleLogout = async () => {
    sessionStorage.removeItem('2fa_verified');
    window.location.href = '/';
  };

  // 로딩 중일 때 로딩 화면 표시
  if (loading || checking2FA) {
    return (
      <div style={{
        minHeight: '100vh',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        backgroundColor: '#f8f9fa'
      }}>
        <div style={{
          textAlign: 'center',
          padding: '40px'
        }}>
          <div style={{
            fontSize: '2rem',
            marginBottom: '20px'
          }}>
            🔐
          </div>
          <h2 style={{
            margin: '0 0 10px 0',
            color: '#333'
          }}>
            Password Wallet
          </h2>
          <p style={{
            margin: '0',
            color: '#666'
          }}>
            로딩 중...
          </p>
          
          {/* 로딩 스피너 */}
          <div style={{
            marginTop: '20px',
            display: 'inline-block',
            width: '40px',
            height: '40px',
            border: '3px solid #f3f3f3',
            borderTop: '3px solid #4285f4',
            borderRadius: '50%',
            animation: 'spin 1s linear infinite'
          }} />
          
          {/* CSS 애니메이션 */}
          <style>
            {`
              @keyframes spin {
                0% { transform: rotate(0deg); }
                100% { transform: rotate(360deg); }
              }
            `}
          </style>
        </div>
      </div>
    );
  }

  // 인증되지 않은 경우 로그인 화면 표시
  if (!user) {
    return <Login />;
  }

  // 2FA가 필요하고 아직 인증되지 않은 경우
  if (twoFactorRequired && !twoFactorVerified) {
    return (
      <TwoFactorVerification
        userId={user.uid}
        onVerifySuccess={handleTwoFactorSuccess}
        onCancel={handleLogout}
      />
    );
  }

  // 인증된 경우 자식 컴포넌트 렌더링
  return children;
};

export default ProtectedRoute;
